import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import Navbar from "../Navbar/Navbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = location?.search?.split("?token=")[1]?.split("&studyName")[0];

  if (token) {
    const decoded = jwtDecode(token);
    let studyName = location?.search
      ?.split("?token=")[1]
      ?.split("&studyName")[1];
    studyName = decodeURIComponent(studyName?.split("=")[1]);
    if (decoded) {
      localStorage.setItem("roleId", decoded?.UserId);
      localStorage.setItem("role", decoded?.Role);
      localStorage.setItem("studyName", studyName);
    }
    localStorage.setItem("access_token", token);
  }

  const access_token = localStorage?.getItem("access_token");

  useEffect(() => {
    if (!access_token) {
      navigate("/unAuthorize");
    }
  }, [access_token]);

  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default Home;
